import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=d3e2fe22&scoped=true&lang=pug&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.scss?vue&type=style&index=0&id=d3e2fe22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e2fe22",
  null
  
)

export default component.exports